<template src="./template.html"></template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import CostTable from '../../modules/01_costtable';
import PageHeading from '../../modules/03_page_heading';
import PanelBox from '../../modules/06_panel_box';

export default {
  components: { CostTable, PageHeading, PanelBox },
  data() {
    return {
      panels: [],
      update: 1,
      proceed: true,
      errorBoxPosition : '',
      required: 'Module must have a name',
    }
  },
  computed: {
    ...mapGetters([
      'get_selected_panels', 'get_panel_by_id', 'get_wording', 
      'get_owner', 'get_order_created', 'get_selection', 'get_selected_building_slug']),
  },
  props: ['step'],
  beforeMount () {
    this.$store.dispatch('UPDATE_STEPS', this.$props.step);
  },
  created () {
    // Check route to redirect
    if( this.get_order_created ){
      this.$router.push('/');
    }else if( this.get_selection.activeField === 0 ){
      this.$router.push(`/${this.$route.params.buildingAddress}`);
    }else if( this.get_selected_panels.length === 0 ){
      this.$router.push(`/${this.$route.params.buildingAddress}/step-2`);
    }

    // Populate panels
    for ( var ii = 0; ii < this.get_selected_panels.length; ii++ ) {
      this.panels.push({
        id: this.get_selected_panels[ii].id,
        valid: false,
      });
    }
  },
  watch: {
    update: function () {
      for(var ii = 0; ii < this.panels.length; ii++){
        if( this.panels[ii].valid === false ){
          this.proceed = false;
          return;
        }else{
          this.proceed = true;
        }
      }
      
      if( this.proceed ){
        this.nextStep();
      }
    },
  },
  methods: {
    handleError(el, position){
      if( position <  this.errorBoxPosition || this.errorBoxPosition === ''){
        window.scroll(0,position);
      }
      this.errorBoxPosition = position;
    },
    emitedFromPanel(el, validator){
      for(var ii = 0; ii < this.panels.length; ii++){
        if( this.panels[ii].id === el.panel.id ){
          this.$set(this.panels[ii], 'valid', validator);
        }
      }
      this.update = Math.floor(Math.random() * 10000) + 1;
    },
    checker() {
      this.errorBoxPosition = '';
      for (var ii = 0; ii < this.$refs.panel.length; ii++) {
        this.$refs.panel[ii].triggerPanel();
      }
    },
    nextStep() {
      if( this.proceed ) {
        this.$router.push(`/${this.$route.params.buildingAddress}/step-4`);
      }
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/pages/03_options/index.vue